import type { DashboardExperienceRootSectionItem } from '@library/api-dashboard-experience'
import React from 'react'

import {
  type DashboardExperienceActionClickHandler,
  renderDashboardExperienceItem,
} from './dashboardExperienceItemRenderer'

type DashboardSectionItemProps = {
  item: DashboardExperienceRootSectionItem
  onActionClick: DashboardExperienceActionClickHandler
}

export function DashboardSectionItem({ item, onActionClick }: DashboardSectionItemProps) {
  return <>{renderDashboardExperienceItem(item, onActionClick)}</>
}
